import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      app: {
        name: 'Quran Memorization',
        tagline: 'Track your journey to memorize the Holy Quran'
      },
      nav: {
        dashboard: 'Dashboard',
        pages: 'Pages',
        surahs: 'Surahs',
        settings: 'Settings',
        profiles: 'Profiles'
      },
      auth: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
        signOut: 'Sign Out',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        name: 'Full Name',
        forgotPassword: 'Forgot Password?',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?'
      },
      dashboard: {
        welcome: 'Welcome',
        progress: 'Progress',
        pagesMemorized: 'Pages Memorized',
        needsReview: 'Needs Review',
        lastReview: 'Last Review',
        streak: 'Day Streak',
        totalPages: 'of 604 pages',
        recentActivity: 'Recent Activity',
        quickActions: 'Quick Actions',
        addPage: 'Add Page',
        reviewDue: 'Review Due'
      },
      profile: {
        title: 'Profile',
        name: 'Profile Name',
        create: 'Create Profile',
        edit: 'Edit Profile',
        delete: 'Delete Profile',
        maxReviewDays: 'Max Days Between Reviews',
        shareProfile: 'Share Profile',
        sharedWith: 'Shared With',
        readOnly: 'Read Only',
        canEdit: 'Can Edit'
      },
      page: {
        number: 'Page',
        memorizedAt: 'Memorized On',
        reviewedAt: 'Last Reviewed',
        score: 'Score',
        notes: 'Notes',
        save: 'Save',
        cancel: 'Cancel',
        markMemorized: 'Mark as Memorized',
        addReview: 'Add Review'
      },
      surah: {
        name: 'Surah Name',
        pages: 'Pages'
      },
      settings: {
        title: 'Settings',
        language: 'Language',
        theme: 'Theme',
        notifications: 'Notifications',
        account: 'Account Settings',
        changePassword: 'Change Password',
        deleteAccount: 'Delete Account',
        deleteAccountWarning: 'Once you delete your account, there is no going back. Please be certain.'
      },
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        close: 'Close',
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        confirm: 'Confirm',
        search: 'Search'
      },
      scores: {
        excellent: 'Excellent',
        good: 'Good',
        fair: 'Fair',
        poor: 'Needs Work'
      }
    }
  },
  ar: {
    translation: {
      app: {
        name: 'حفظ القرآن',
        tagline: 'تتبع رحلتك في حفظ القرآن الكريم'
      },
      nav: {
        dashboard: 'الرئيسية',
        pages: 'الصفحات',
        surahs: 'السور',
        settings: 'الإعدادات',
        profiles: 'الملفات الشخصية'
      },
      auth: {
        signIn: 'تسجيل الدخول',
        signUp: 'إنشاء حساب',
        signOut: 'تسجيل الخروج',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
        name: 'الاسم الكامل',
        forgotPassword: 'نسيت كلمة المرور؟',
        noAccount: 'ليس لديك حساب؟',
        hasAccount: 'لديك حساب بالفعل؟'
      },
      dashboard: {
        welcome: 'مرحباً',
        progress: 'التقدم',
        pagesMemorized: 'صفحات محفوظة',
        needsReview: 'تحتاج مراجعة',
        lastReview: 'آخر مراجعة',
        streak: 'أيام متتالية',
        totalPages: 'من 604 صفحة',
        recentActivity: 'النشاط الأخير',
        quickActions: 'إجراءات سريعة',
        addPage: 'إضافة صفحة',
        reviewDue: 'مراجعة مستحقة'
      },
      profile: {
        title: 'الملف الشخصي',
        name: 'اسم الملف',
        create: 'إنشاء ملف',
        edit: 'تعديل الملف',
        delete: 'حذف الملف',
        maxReviewDays: 'الحد الأقصى للأيام بين المراجعات',
        shareProfile: 'مشاركة الملف',
        sharedWith: 'مشترك مع',
        readOnly: 'قراءة فقط',
        canEdit: 'يمكنه التعديل'
      },
      page: {
        number: 'صفحة',
        memorizedAt: 'تاريخ الحفظ',
        reviewedAt: 'آخر مراجعة',
        score: 'الدرجة',
        notes: 'ملاحظات',
        save: 'حفظ',
        cancel: 'إلغاء',
        markMemorized: 'تحديد كمحفوظ',
        addReview: 'إضافة مراجعة'
      },
      surah: {
        name: 'اسم السورة',
        pages: 'الصفحات'
      },
      settings: {
        title: 'الإعدادات',
        language: 'اللغة',
        theme: 'المظهر',
        notifications: 'الإشعارات',
        account: 'إعدادات الحساب',
        changePassword: 'تغيير كلمة المرور',
        deleteAccount: 'حذف الحساب',
        deleteAccountWarning: 'بمجرد حذف حسابك، لا يمكن التراجع. يرجى التأكد من قرارك.'
      },
      common: {
        save: 'حفظ',
        cancel: 'إلغاء',
        delete: 'حذف',
        edit: 'تعديل',
        add: 'إضافة',
        close: 'إغلاق',
        loading: 'جارٍ التحميل...',
        error: 'حدث خطأ',
        success: 'تم بنجاح',
        confirm: 'تأكيد',
        search: 'بحث'
      },
      scores: {
        excellent: 'ممتاز',
        good: 'جيد',
        fair: 'مقبول',
        poor: 'يحتاج تحسين'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'ar',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
